import { render, staticRenderFns } from "./DonateResultShare.vue?vue&type=template&id=f85a516a&"
import script from "./DonateResultShare.vue?vue&type=script&lang=js&"
export * from "./DonateResultShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports